import { useQuery } from '@tanstack/react-query';
import { profileContainer } from '../../di/container';
import { useAuthStore } from '../../../auth/presentation/store/auth.store';
import { useImpersonationStore } from '@/shared/impersonation/impersonation.store';

export function useProfile() {
  const { auth } = useAuthStore();
  const target = useImpersonationStore((s) => s.target);

  return useQuery({
    // /users/me resolve pela identidade efetiva (mascarada). A key inclui o alvo
    // do act-as para que "eu" e "mascarado" não compartilhem cache.
    queryKey: ['profile', 'me', target?.userId ?? 'self'],
    queryFn: () => profileContainer.repository.getMe(),
    enabled: !!auth,
    retry: false,
  });
}
